export default "__VITE_ASSET__CcTg9WHj__"